// extracted by mini-css-extract-plugin
export var header = "_fo-0";